<template>
  <div class="order-more" v-title data-title="订单详情">
    <!-- <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/order-list')"> 
      <p>
        订单详情
      </p>
    </header> -->
    <section>
      <div class="order-msg">
        <!-- 标题 -->
        <p class="order-title">
          <span>
            {{orderMsg.goodname}}
          </span>
          <span v-if="orderMsg.pay_status == 1">
            已支付
          </span>
          <span v-if="orderMsg.pay_status == 0">
            未支付
          </span>
        </p>
        <p class="order-img">
          <img :src=orderMsg.thumbnil alt="">
        </p>
        <!-- 订单信息 -->
        <div class="o-msg">
          <p>
            购买日期：
          </p>
          <p>
            {{orderMsg.create_time}}
          </p>
        </div>
        <div class="o-msg">
          <p>
            下单人姓名：
          </p>
          <p>
            {{orderMsg.realname}}
          </p>
        </div>
        <div class="o-msg">
          <p>
            实际付款：
          </p>
          <p>
            {{orderMsg.total_price}}元
          </p>
        </div>
        <div class="o-msg">
          <p>
            联系方式：
          </p>
          <p>
            {{orderMsg.mobile}}
          </p>
        </div>
        <div class="o-msg">
          <p>
            身份证号码：
          </p>
          <p>
            {{orderMsg.card_no}}
          </p>
        </div>
        <!-- <div class="o-msg">
          <p>
            会员卡编号：
          </p>
          <p>
            020202020
          </p>
        </div> -->
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data(){
    return{
      orderMsg: [], // 订单详情
    }
  },
  created(){
    let id = this.$route.query.id
    // console.log(id)
    // 订单详情查询
    this.$axios.get(this.domain.url+"/api/order/index/detail/?id="+id).then((res) => {
      // console.log(res.data.data)
      this.orderMsg = res.data.data
    })
  }
}
</script>
<style lang="less" scoped>
  .order-more{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      background-image: url(../../assets/images/order-img/order-more-img/touming.png);
      background-repeat: no-repeat;
      background-size: 7.5rem 5.46rem;
      .order-msg{
        width: 6.9rem;
        height: 9.32rem;
        background: #ffffff;
        border-radius: .2rem;
        margin: 0 auto;
        margin-top: .99rem;
        .order-title{
          span{
            &:first-child{
              display: inline-block;
              font-size: 0.36rem;
              font-family: PingFang SC;
              font-weight: bold;
              color:rgba(51,51,51,1);
              line-height: .36rem;
              margin-left: .19rem;
              margin-top: .39rem;
            }
            &:last-child{
              font-size: 0.28rem;
              font-family: PingFang SC;
              font-weight: bold;
              color:rgba(239,130,1,1);
              line-height: .36rem;
              float: right;
              line-height: .36rem;
              margin-top: .44rem;
              margin-right: .24rem;
            }
          }
        }
        .order-img{
          img{
            width: 2.24rem;
            height: 1.33rem;
            margin-left: .21rem;
            margin-top: .19rem;
          }
        }
        .o-msg{
          width: 6.46rem;
          height: .88rem;
          margin: 0 auto;
          border-bottom: .01rem #E4E4E4 solid;
          line-height: .88rem;
          p{
            &:first-child{
              float: left;
              font-family: PingFang-SC;
              color: #333333;
              font-size: 0.3rem;
            }
            &:last-child{
              float: right;
              font-family: PingFang-SC;
              color: #999999;
              font-size: 0.3rem;
            }
          }
        }
      }
    }
  }
</style>